import { Wrapper, useBreadcrumbRoutes } from '@maxtropy/components';
import AccuracyAnalysis from './components/AccuracyAnalysis';
import CurtailmentAnalysis from './components/CurtailmentAnalysis';
import DemandAnalysis from './components/DemandAnalysis';
import RevenueCalculation from './components/RevenueCalculation';
import styles from './index.module.scss';

const OperationAnalysisReport = () => {
  const routesContext = useBreadcrumbRoutes();

  return (
    <Wrapper className={styles.wrapper} routes={[...(routesContext?.routes ?? [])]} hasPadding={false}>
      <main className={styles.page}>
        <CurtailmentAnalysis />
        <DemandAnalysis />
        <AccuracyAnalysis />
        <RevenueCalculation />
      </main>
    </Wrapper>
  );
};

export default OperationAnalysisReport;
